export const ID_TOKEN = 'id_token_eydi&KDIS?NChrCm^GK)rbVQr#7Ts2JYph/hBpBUvCM';
export const TYPE_COMPTE = 'type_compte_eydi&KDIS?NChrCm^GK)rbVQr#7Ts2JYph/hBpBUvCM';

export function getToken()
{
  try
  {
    return getLocalStorage(ID_TOKEN);
  }
  catch(e)
  {
    return undefined;
  }
}

export function setLocalStorage(key, value) {
  try
  {
    localStorage.setItem(key, value);
    const verif = getLocalStorage(key);

    return verif !== null && verif !== undefined && verif === value;
  }
  catch(e)
  {
    return false;
  }

}

export function deleteLocalStorage(key) {
  try
  {
    localStorage.removeItem(key);
    return true;
  }
  catch(e)
  {
    return false;
  }
}

export function clearLocalStorage() {
  try
  {
    localStorage.clear();
    return true;
  }
  catch(e)
  {
    return false;
  }
}

export function getLocalStorage(key)
{
  try
  {
    return localStorage.getItem(key);
  }
  catch(e)
  {
    return undefined;
  }
}


// WEBPACK FOOTER //
// ./src/tools/localStorage.js